export const modalTypes = {
    DELETE: 'delete',
    BLOCK: 'block',
    UNBLOCK: 'unblock',
    EDIT: 'edit',
    REPLY: 'reply',
    CANCEL:'cancel'
};
